/** @format */

import PairingModelComponent from '../../components/pairing-model/pairing-model.component';
const MaintenancePage = () => {
  return (
    <div>
      <PairingModelComponent></PairingModelComponent>
    </div>
  );
};

export default MaintenancePage;
